import {
  ArrowClockwiseIcon,
  EyeIcon,
  WarningCircleIcon,
} from '@phosphor-icons/react';
import { FC } from 'react';

import { BaseButton, RadialBackground } from 'waldur-ui';

import { translate } from '@/i18n';
import '@/navigation/header/search/NoResult.scss';
import { useModal } from '@/modal/actions';

import { lazyComponent } from './core/lazyComponent';

const ErrorTraceDialog = lazyComponent(() =>
  import('@/ErrorTraceDialog').then((module) => ({
    default: module.ErrorTraceDialog,
  })),
);

interface ErrorViewProps {
  error: any;
}

export const ErrorView: FC<ErrorViewProps> = ({ error }) => {
  const { openDialog } = useModal();
  const openErrorTraceDialog = () =>
    openDialog(ErrorTraceDialog, { error } as any);

  return (
    <div className="search-error">
      <RadialBackground className="background" />
      <div className="text-center flex flex-col items-center pb-8 relative z-1">
        <div className="icon-square icon-lg error-icon">
          <WarningCircleIcon weight="bold" size={24} />
        </div>

        <div>
          <h4>{translate('Something went wrong')}</h4>
          <div className="flex flex-col items-center text-quaternary text-sm">
            <p className="mb-0">
              {translate('An error occurred.')}
              <br />
              {translate('Try reloading or go back to the previous page')}
            </p>
          </div>
        </div>
        <div className="actions flex gap-3 mt-1.5">
          <BaseButton
            variant="tertiary"
            onClick={openErrorTraceDialog}
            label={translate('Show error trace')}
            iconNode={<EyeIcon weight="bold" />}
            size="lg"
          />
          <BaseButton
            variant="tertiary"
            onClick={() => location.reload()}
            label={translate('Reload')}
            iconNode={<ArrowClockwiseIcon weight="bold" />}
            size="lg"
          />
        </div>
      </div>
    </div>
  );
};
